











import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { getStorage } from '@/utils/storage';
import { Route } from 'vue-router';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';
import ToolChartColorPicker from '@/views/tool/chartcolor/Picker.vue';
import ToolImgColorPicker from '@/views/tool/imgcolor/Picker.vue';

@Component({
  components: { TooltipIcon, ToolImgColorPicker, ToolChartColorPicker },
})
export default class MainTopBar extends Vue {
  @namespace('login').Action('logout') public logout!: () => void;

  public title = '';
  public userInfo = JSON.parse(getStorage('userInfo') || '{}');

  public get isPlatform() {
    return this.userInfo.orgType === 0;
  }

  public get profileColor() {
    return /^(\/profile)/.test(this.$route.fullPath) ? 'primary' : '';
  }

  // 进入个人中心
  public gotoProfile() {
    this.$router.push({ name: 'profile' });
  }

  // 设置标题
  @Watch('$route', { immediate: true })
  public routeChange(route: Route) {
    this.title = route.meta.title || '';
  }
}
